<template>
  <div>
    <template v-if="!logs">
      <vue-content-loading :width="800" :height="450">
        <rect v-for="x in 15" :key="x" x="10" :y="15*x*1.4" rx="5" ry="5" width="720" height="6" />
      </vue-content-loading>
    </template>
    <template>
      <div id="accordion" class="log-wrap mb-3">
        <div v-for="log in logs"
             :key="log.id"
        >
          <div class="row align-items-center log-box collapsed"
               :id="'heading-system' + log.id"
               data-toggle="collapse" data-parent="#accordion"
               :data-target="'#collapse-system-' + log.id"
               :aria-controls="'#collapse-system-' + log.id"
               @click="toggleLog(log.id)"
          >
            <div class="col-1 circle-border-line d-none d-lg-block d-xl-block d-md-block">
              <i class="fa fa-circle-thin" />
            </div>
            <div class="col-12 col-md-3 col-lg-3 col-xl-3 log-description">
              <p class="mb-0 log-description">{{ log.description }}</p>
              <p class="mb-0 log-date">{{ log.date }}</p>
            </div>
            <div class="col-7 col-md-3 col-lg-3 col-xl-3">
              <img :src="(log.user && log.user.images && log.user.images[0]) ? log.user.images[0].url : '/static/images/avatar.png'" class="log-avatar" />
              <p class="log-name">{{ log.user ? log.user.first_name : 'System' }} {{ log.user ? log.user.last_name : '' }}</p>
            </div>
            <div class="col-5">
              <span :class="{'mod-icon-plus': !expandedLogs.includes(log.id), 'mod-icon-minus': expandedLogs.includes(log.id)}" />
            </div>
          </div>
          <div :id="'collapse-system-' + log.id" class="collapse" aria-expanded="false" :aria-labelledby="'heading-system-' + log.id"
               data-parent="#accordion"
          >
            <div class="row">
              <div class="col-1" />
              <div class="col-11">
                <table class="table m-table table-hover log-table">
                  <thead class="m-table__heading">
                    <tr>
                      <th>Property</th>
                      <th>Old Value</th>
                      <th>New Value</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(change, key) in log.changes"
                        :key="`change-prefix-${key}`"
                    >
                      <td>{{ key }}</td>
                      <td>{{ change.old }}</td>
                      <td>{{ change.new }}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
      <pagination :change-page="changePage" :meta="meta" />
    </template>
  </div>
</template>

<script>
import axios from 'axios';
import Pagination from './Pagination';

export default {
  components: {
    Pagination,
  },
  props: {
    model: {
      type: Object,
      default: null,
    },
    type: {
      type: String,
      default: '',
    },
  },
  data: () => ({
    logs: null,
    page: '',
    meta: '',
    expandedLogs: [],
  }),
  mounted() {
    this.loadLog();
  },
  methods: {
    loadLog() {
      axios
        .get(`${this.type}/${this.model.id}/logs?page=${this.page}`)
        .then(res => {
          this.logs = res.data.data;
          this.meta = res.data.meta;
        })
        .catch(err => this.errors.record(err.response.data.error));
    },
    changePage(pageNum) {
      this.logs = null;
      this.page = pageNum;
      this.loadLog();
    },
    toggleLog(id) {
      if (this.expandedLogs.includes(id)) {
        this.expandedLogs = this.expandedLogs.filter(logId => logId !== id);
      } else {
        this.expandedLogs.push(id);
      }
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/ModelLog.vue